import React, { Component } from 'react';
import { compose } from 'recompose';
import {
  withRouter
} from 'react-router-dom';

import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import SignInForm from './SignInForm';
import { PasswordForgetLink } from './PasswordForget';

import bg from './bg-02.jpg';

const styles = theme => ({
  root: {
    minHeight: '100vh',
    backgroundImage: `url(${bg})`,
    backgroundSize: 'cover',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    width: "400px",
    display: "flex",
    flexDirection: "column",
  },
  title: {
    alignSelf: "center",
    marginTop: theme.spacing.unit*4,
  }
});

const SignInPage = ({ classes, history }) =>
  <div className={classes.root}>
    <Card className={classes.card}>
      <Typography className={classes.title} variant="display1">SIGN IN</Typography>
      <SignInForm history={history} />
    </Card>
  </div>

export default compose(
  withRouter,
  withStyles(styles)
)(SignInPage);



// WEBPACK FOOTER //
// ./src/components/auth/SignIn.jsx